var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M38.345,88.273C17.167,88.273,0,105.44,0,126.618v258.759c0,21.177,17.167,38.345,38.345,38.345 h132.322V88.273H38.345z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.67,
    y: 88.277,
    style: {
      fill: "#F5F5F5"
    },
    width: 170.67,
    height: 335.45
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M473.655,88.273H341.333v335.448h132.322c21.177,0,38.345-17.167,38.345-38.345V126.618 C512,105.44,494.833,88.273,473.655,88.273z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC855"
    },
    points: "253.773,212.107 248.711,214.638 253.368,216.561 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M256,305.649c-28.135,0-51.023-22.89-51.023-51.023c0-17.478,8.797-33.548,23.531-42.989l1.31,2.046 c-14.034,8.993-22.412,24.299-22.412,40.943c0,26.795,21.8,48.594,48.594,48.594v2.43l0,0V305.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M226.798,308.833c1.944,0.396,4.943-0.117,8.023-1.551c3.081-1.436,5.402-3.402,6.349-5.145 c-1.944-0.396-4.943,0.116-8.023,1.551C230.068,305.124,227.746,307.09,226.798,308.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M241.172,302.137c0.396-1.944-0.117-4.943-1.551-8.023c-1.436-3.081-3.402-5.402-5.145-6.349 c-0.396,1.944,0.116,4.943,1.551,8.023C237.462,298.867,239.428,301.189,241.172,302.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M216.633,302.593c1.865,0.678,4.907,0.61,8.164-0.356c3.258-0.968,5.843-2.572,7.036-4.157 c-1.865-0.678-4.907-0.61-8.164,0.356C220.412,299.403,217.826,301.008,216.633,302.593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M231.834,298.079c0.678-1.865,0.61-4.907-0.356-8.164c-0.968-3.257-2.572-5.843-4.157-7.036 c-0.678,1.865-0.61,4.907,0.356,8.164C228.644,294.301,230.249,296.886,231.834,298.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M207.231,294.085c1.713,1.001,4.717,1.482,8.096,1.116c3.379-0.366,6.21-1.481,7.668-2.826 c-1.713-1.001-4.717-1.482-8.096-1.116C211.52,291.626,208.689,292.74,207.231,294.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M222.995,292.374c1.001-1.713,1.482-4.717,1.116-8.096c-0.366-3.379-1.481-6.21-2.826-7.668 c-1.001,1.713-1.482,4.717-1.116,8.096C220.536,288.085,221.65,290.917,222.995,292.374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M199.458,282.336c1.508,1.289,4.38,2.294,7.77,2.531s6.375-0.358,8.047-1.423 c-1.508-1.289-4.38-2.294-7.77-2.531C204.115,280.676,201.131,281.27,199.458,282.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M215.276,283.444c1.289-1.508,2.294-4.381,2.531-7.77c0.237-3.39-0.358-6.375-1.423-8.047 c-1.289,1.508-2.294,4.38-2.531,7.77C213.615,278.788,214.21,281.771,215.276,283.444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M194.908,269.394c1.204,1.577,3.799,3.164,7.064,4.109c3.264,0.946,6.306,0.991,8.167,0.301 c-1.204-1.577-3.799-3.164-7.064-4.109C199.81,268.75,196.768,268.704,194.908,269.394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M210.138,273.804c1.577-1.204,3.164-3.799,4.109-7.064c0.946-3.264,0.991-6.306,0.301-8.167 c-1.577,1.204-3.164,3.799-4.109,7.064C209.494,268.902,209.449,271.944,210.138,273.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M192.982,254.283c0.758,1.834,2.858,4.034,5.77,5.788c2.912,1.753,5.839,2.58,7.815,2.391 c-0.758-1.834-2.858-4.034-5.77-5.788C197.885,254.921,194.957,254.095,192.982,254.283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M206.567,262.462c1.834-0.758,4.034-2.858,5.788-5.77c1.753-2.912,2.58-5.839,2.391-7.815 c-1.833,0.758-4.034,2.858-5.788,5.77C207.206,257.559,206.378,260.487,206.567,262.462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M194.807,240.016c0.356,1.952,1.949,4.544,4.428,6.869c2.479,2.325,5.17,3.746,7.139,3.977 c-0.356-1.952-1.949-4.544-4.428-6.869C199.467,241.668,196.778,240.246,194.807,240.016z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M206.375,250.862c1.952-0.356,4.544-1.949,6.869-4.428c2.324-2.479,3.746-5.17,3.977-7.139 c-1.952,0.356-4.544,1.949-6.869,4.428C208.028,246.201,206.605,248.891,206.375,250.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M201.975,224.579c-0.408,1.941,0.085,4.943,1.501,8.033c1.416,3.09,3.368,5.423,5.105,6.382 c0.408-1.941-0.085-4.943-1.501-8.033C205.664,227.87,203.712,225.536,201.975,224.579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M208.58,238.994c1.941,0.408,4.943-0.085,8.033-1.501c3.09-1.416,5.423-3.368,6.382-5.105 c-1.941-0.408-4.943,0.085-8.033,1.501S209.538,237.257,208.58,238.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M210.546,213.146c-0.915,1.76-1.247,4.785-0.714,8.141c0.533,3.357,1.785,6.13,3.201,7.519 c0.915-1.76,1.247-4.785,0.714-8.141C213.214,217.308,211.961,214.536,210.546,213.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M213.034,228.806c1.76,0.915,4.785,1.247,8.141,0.714c3.357-0.533,6.13-1.785,7.519-3.201 c-1.76-0.915-4.785-1.247-8.141-0.714C217.196,226.138,214.423,227.39,213.034,228.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M218.951,205.189c-1.164,1.607-1.938,4.548-1.906,7.947c0.033,3.399,0.864,6.326,2.059,7.908 c1.164-1.607,1.938-4.548,1.905-7.947C220.977,209.699,220.147,206.771,218.951,205.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M219.105,221.044c1.607,1.164,4.548,1.938,7.947,1.906c3.399-0.033,6.325-0.864,7.908-2.059 c-1.607-1.164-4.548-1.938-7.947-1.906C223.615,219.018,220.689,219.849,219.105,221.044z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M223.183,216.875c1.977,0.16,4.894-0.707,7.78-2.502c2.887-1.794,4.956-4.024,5.688-5.868 c-1.977-0.16-4.894,0.707-7.78,2.502C225.985,212.801,223.916,215.031,223.183,216.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M256,305.649v-2.43c26.794,0,48.594-21.799,48.594-48.594c0-16.644-8.378-31.951-22.411-40.943 l1.31-2.046c14.734,9.441,23.531,25.512,23.531,42.989C307.023,282.759,284.135,305.649,256,305.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M285.202,308.833c-1.944,0.396-4.943-0.117-8.023-1.551c-3.081-1.436-5.402-3.402-6.349-5.145 c1.944-0.396,4.943,0.116,8.023,1.551S284.254,307.09,285.202,308.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M270.828,302.137c-0.396-1.944,0.117-4.943,1.551-8.023c1.436-3.081,3.402-5.402,5.145-6.349 c0.396,1.944-0.116,4.943-1.551,8.023C274.538,298.867,272.572,301.189,270.828,302.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M295.367,302.593c-1.865,0.678-4.907,0.61-8.164-0.356c-3.258-0.968-5.843-2.572-7.036-4.157 c1.865-0.678,4.907-0.61,8.164,0.356C291.588,299.403,294.174,301.008,295.367,302.593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M280.165,298.079c-0.677-1.865-0.61-4.907,0.356-8.164c0.968-3.257,2.572-5.843,4.157-7.036 c0.678,1.865,0.61,4.907-0.356,8.164C283.356,294.301,281.751,296.886,280.165,298.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M304.769,294.085c-1.713,1.001-4.717,1.482-8.096,1.116c-3.379-0.366-6.21-1.481-7.668-2.826 c1.713-1.001,4.717-1.482,8.096-1.116C300.48,291.626,303.311,292.74,304.769,294.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M289.005,292.374c-1.001-1.713-1.482-4.717-1.116-8.096c0.366-3.379,1.481-6.21,2.826-7.668 c1.001,1.713,1.482,4.717,1.116,8.096C291.464,288.085,290.35,290.917,289.005,292.374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M312.542,282.336c-1.508,1.289-4.381,2.294-7.77,2.531c-3.391,0.237-6.375-0.358-8.047-1.423 c1.508-1.289,4.38-2.294,7.77-2.531C307.885,280.676,310.869,281.27,312.542,282.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M296.724,283.444c-1.289-1.508-2.294-4.381-2.531-7.77c-0.237-3.39,0.358-6.375,1.423-8.047 c1.289,1.508,2.294,4.38,2.531,7.77C298.385,278.788,297.79,281.771,296.724,283.444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M317.092,269.394c-1.204,1.577-3.799,3.164-7.064,4.109c-3.264,0.946-6.306,0.991-8.167,0.301 c1.204-1.577,3.799-3.164,7.064-4.109S315.232,268.704,317.092,269.394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M301.862,273.804c-1.577-1.204-3.164-3.799-4.109-7.064c-0.946-3.264-0.991-6.306-0.301-8.167 c1.577,1.204,3.164,3.799,4.109,7.064C302.506,268.902,302.551,271.944,301.862,273.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M319.018,254.283c-0.758,1.834-2.858,4.034-5.77,5.788c-2.912,1.753-5.839,2.58-7.815,2.391 c0.758-1.834,2.858-4.034,5.77-5.788C314.115,254.921,317.043,254.095,319.018,254.283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M305.433,262.462c-1.834-0.758-4.034-2.858-5.788-5.77c-1.753-2.912-2.58-5.839-2.391-7.815 c1.833,0.758,4.034,2.858,5.788,5.77C304.794,257.559,305.622,260.487,305.433,262.462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M317.193,240.016c-0.356,1.952-1.949,4.544-4.428,6.869s-5.17,3.746-7.139,3.977 c0.356-1.952,1.949-4.544,4.428-6.869S315.222,240.246,317.193,240.016z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M305.625,250.862c-1.952-0.356-4.544-1.949-6.869-4.428c-2.325-2.479-3.746-5.17-3.977-7.139 c1.952,0.356,4.544,1.949,6.869,4.428C303.972,246.201,305.395,248.891,305.625,250.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M310.026,224.579c0.408,1.941-0.085,4.943-1.501,8.033c-1.416,3.09-3.368,5.423-5.105,6.382 c-0.408-1.941,0.085-4.943,1.501-8.033C306.336,227.87,308.288,225.536,310.026,224.579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M303.42,238.994c-1.941,0.408-4.943-0.085-8.033-1.501s-5.423-3.368-6.382-5.105 c1.941-0.408,4.943,0.085,8.033,1.501C300.128,235.305,302.462,237.257,303.42,238.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M301.454,213.146c0.915,1.76,1.247,4.785,0.714,8.141c-0.533,3.357-1.785,6.13-3.201,7.519 c-0.915-1.76-1.247-4.785-0.714-8.141S300.039,214.536,301.454,213.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M298.966,228.806c-1.76,0.915-4.785,1.247-8.141,0.714c-3.357-0.533-6.13-1.785-7.519-3.201 c1.76-0.915,4.785-1.247,8.141-0.714C294.804,226.138,297.577,227.39,298.966,228.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M293.049,205.189c1.164,1.607,1.938,4.548,1.905,7.947s-0.864,6.326-2.059,7.908 c-1.164-1.607-1.938-4.548-1.905-7.947C291.023,209.699,291.853,206.771,293.049,205.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M292.895,221.044c-1.607,1.164-4.548,1.938-7.947,1.906c-3.399-0.033-6.325-0.864-7.908-2.059 c1.607-1.164,4.548-1.938,7.947-1.906C288.385,219.018,291.311,219.849,292.895,221.044z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M288.817,216.875c-1.977,0.16-4.894-0.707-7.78-2.502s-4.956-4.024-5.688-5.868 c1.977-0.16,4.894,0.707,7.78,2.502C286.015,212.801,288.084,215.031,288.817,216.875z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#966446"
    },
    d: "M228.146,294.348l-8.844,8.844l-4.361-8.723l13.084-13.084l4.361,4.361l-1.26,3.779 C230.52,291.344,229.5,292.994,228.146,294.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9B9"
    },
    d: "M275.997,229.053l-47.972,47.972c-1.204,1.204-1.204,3.157,0,4.361l2.18,2.18l8.723-8.723 l34.889-39.251l4.361-4.361L275.997,229.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#966446"
    },
    d: "M239.83,269.58c-0.578,0.578-0.904,1.363-0.904,2.18v3.084l34.889-39.251L239.83,269.58z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A0A0A0"
    },
    points: "278.177,231.233 275.997,229.053 273.816,231.233 275.997,233.415 278.177,235.595  302.164,207.248 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#966446"
    },
    d: "M286.284,294.348l8.844,8.844l4.361-8.723l-13.084-13.084l-4.361,4.361l1.26,3.779 C283.91,291.344,284.93,292.994,286.284,294.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9B9"
    },
    d: "M238.433,229.053l47.972,47.972c1.204,1.204,1.204,3.157,0,4.361l-2.18,2.18l-8.723-8.723 l-34.889-39.251l-4.361-4.361L238.433,229.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#966446"
    },
    d: "M274.6,269.58c0.578,0.578,0.904,1.363,0.904,2.18v3.084l-34.889-39.251L274.6,269.58z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A0A0A0"
    },
    points: "236.253,231.233 238.433,229.053 240.614,231.233 238.433,233.415 236.253,235.595  212.266,207.248 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9B9"
    },
    d: "M239.315,292.534l2.167,1.976c7.906-8.668,21.741-23.837,43.673-43.529 C285.156,250.982,266.986,262.197,239.315,292.534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M233.184,301.431L233.184,301.431c-0.778-0.71-0.833-1.916-0.124-2.694l4.644-5.092 c0.71-0.778,1.916-0.833,2.694-0.124l0,0c0.778,0.71,0.833,1.916,0.124,2.694l-4.644,5.092 C235.168,302.086,233.962,302.141,233.184,301.431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC855"
    },
    d: "M237.556,290.93l-1.258,0.561c-1.119,0.557-4.063,2.222-4.57,4.595 c-0.242,1.124,0.099,2.219,0.972,3.255c0.083-0.214,0.196-0.422,0.361-0.601l0.585-0.641c-0.396-0.574-0.605-1.138-0.486-1.704 c0.318-1.484,2.298-2.809,3.542-3.466l5.564,5.075l1.384-1.517L237.556,290.93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9B9"
    },
    d: "M275.093,294.933l-2.167,1.976c-7.906-8.668-21.741-23.837-43.673-43.529 C229.252,253.381,247.422,264.596,275.093,294.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M281.224,303.832L281.224,303.832c0.778-0.71,0.833-1.916,0.124-2.694l-4.644-5.092 c-0.71-0.778-1.916-0.833-2.694-0.124l0,0c-0.778,0.71-0.833,1.916-0.124,2.694l4.644,5.092 C279.24,304.486,280.446,304.541,281.224,303.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC855"
    },
    d: "M276.852,293.329l1.258,0.561c1.119,0.557,4.063,2.222,4.57,4.595 c0.242,1.124-0.099,2.219-0.972,3.255c-0.083-0.214-0.196-0.421-0.361-0.601l-0.585-0.641c0.396-0.574,0.605-1.138,0.486-1.704 c-0.318-1.484-2.298-2.809-3.542-3.466l-5.564,5.075l-1.384-1.517L276.852,293.329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69B469"
    },
    d: "M258.161,214.683c0.17-0.422,0.268-0.879,0.268-1.362c0-2.013-1.632-3.645-3.645-3.645 c-2.013,0-3.645,1.632-3.645,3.645c0,1.199,0.587,2.254,1.482,2.919c-1.318,10.585,9.119,11.394,13.096,12.874 c6.035,2.246,13.603,6.787,13.127,19.484c-0.462,12.342-8.267,24.251-8.267,24.251l6.479-8.808 c-2.369,10.02-7.901,22.784-21.057,37.963c0,0,8.995-8.799,16.501-20.146c-5.523,12.993-11.642,25.005-11.642,25.005 s10.833-14.072,19.59-38.419C291.065,238.927,268.732,221.193,258.161,214.683z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239,
    y: 258.267,
    style: {
      fill: "#F4E08F"
    },
    width: 9.719,
    height: 4.86
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ECD077"
    },
    cx: 239,
    cy: 263.127,
    r: 4.86
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ECD077"
    },
    cx: 239,
    cy: 231.547,
    r: 4.86
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF0A8"
    },
    d: "M268.148,236.403c2.684,0,4.86-2.176,4.86-4.86s-2.176-4.86-4.86-4.86h-29.156 c2.684,0,4.86,2.176,4.86,4.86s-2.176,4.86-4.86,4.86s-4.86-2.176-4.86-4.86c0,8.157,6.826,18.019,9.027,26.727 c0,0,0.692,2.176,0.692,4.86c0,2.684-2.176,4.86-4.86,4.86h29.156c2.684,0,4.86-2.176,4.86-4.86c0-8.157-6.826-18.019-9.027-26.727 L268.148,236.403L268.148,236.403z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4E08F"
    },
    d: "M243.852,231.545c0,2.684-2.176,4.86-4.86,4.86h29.156c2.684,0,4.86-2.176,4.86-4.86H243.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4E08F"
    },
    d: "M243.852,263.13c0,2.684-2.176,4.86-4.86,4.86h29.156c2.684,0,4.86-2.176,4.86-4.86H243.852z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGt);
export default __webpack_public_path__ + "static/media/gt.018431122b4a4469435352903bc76463.svg";
export { ForwardRef as ReactComponent };